export const OUTCOME_EVIDENCE_UNAVAILABLE = Object.freeze({
  status: "unavailable",
  label: "Unavailable",
  reason: "No delivery-confirmed outcome feed or approved comparison method is connected.",
  effect:
    "Publication, operational completion, and changes in opportunity signals cannot be presented as campaign outcomes.",
});

export function campaignLifecycleFor(campaign) {
  const workflow = campaign.workflowStatus;
  const governance = campaign.governance?.overall;
  const isPublished = ["deployed", "completed"].includes(workflow);
  const isApproved = ["approved", "deployed", "completed"].includes(workflow);
  return [
    {
      label: "Setup",
      status: workflow === "draft" ? "not_started" : "complete",
      statusLabel: workflow === "draft" ? "In progress" : "Complete",
      detail: `Version ${campaign.version || 1}`,
    },
    {
      label: "Governance",
      status:
        governance === "fail"
          ? "blocked"
          : workflow === "ready_for_review"
            ? "awaiting_review"
            : isApproved
              ? "complete"
              : governance || "not_started",
      statusLabel:
        governance === "fail"
          ? "Blocked"
          : workflow === "ready_for_review"
            ? "Awaiting approval"
            : isApproved
              ? "Approved"
              : governance
                ? governance === "warn"
                  ? "Checks complete with warning"
                  : "Checks passed; not approved"
                : "Not checked",
      detail: isApproved ? "Independent decision recorded" : "Automated checks do not grant approval",
    },
    {
      label: "Publication",
      status:
        governance === "fail"
          ? "blocked"
          : isPublished
            ? "published"
            : workflow === "approved"
              ? "available"
              : "not_started",
      statusLabel:
        governance === "fail"
          ? "Blocked"
          : isPublished
            ? "Published"
            : workflow === "approved"
              ? "Ready to publish"
              : "Not started",
      detail: isPublished ? "Definition available downstream" : "Requires approval first",
    },
    {
      label: "Delivery",
      status: "unavailable",
      statusLabel: "Not reported",
      detail: isPublished ? "Managed by the authorized delivery system" : "Begins after publication",
    },
    {
      label: "Measurement",
      status: OUTCOME_EVIDENCE_UNAVAILABLE.status,
      statusLabel: "Not reported",
      detail: "No outcome evidence is connected",
    },
  ];
}

export function publicationState(value) {
  if (value === "ready") return { status: "published", label: "Published definition" };
  if (value === "blocked") return { status: "blocked", label: "Publication blocked" };
  return { status: "not_started", label: "Not published" };
}

export function deliveryEvidenceState(deployment) {
  if (deployment?.suppressedMetrics?.includes("contactedMembers")) {
    return { kind: "suppressed", reason: "Confirmed-contact count is below the privacy threshold." };
  }
  if (Number(deployment?.contactedMembers) > 0) {
    return { kind: "available", status: "available", label: "Confirmed contact activity" };
  }
  return {
    kind: "unavailable",
    status: "unavailable",
    label: "Unavailable",
    reason: "No confirmed contact records; publication does not prove delivery.",
  };
}
